<template>
    <div class="wrapper">
        <div class="my-header">
            <van-nav-bar
                    title="收款记录"
                    left-text="返回"
                    left-arrow
                    @click-left="onClickLeft"
                    @click-right="show = true"
            >
                <van-icon name="search" slot="right" />
            </van-nav-bar>
<!--            <BaseHeader :title="'收款记录'" :show="true" @handleSearch="show = true"/>-->
            <div class="search-content">
                <van-popup v-model="show" position="top">
                    <div class="search-box">
                        <div class="option">
                            <van-radio-group v-model="type">
                                <van-cell title="全部" clickable @click="radio = '3'">
                                    <van-radio slot="right-icon" name="3" />
                                </van-cell>
                                <van-cell title="付款消费" clickable @click="radio = '0'">
                                    <van-radio slot="right-icon" name="0" />
                                </van-cell>
                                <van-cell title="充值消费" clickable @click="radio = '1'">
                                    <van-radio slot="right-icon" name="1" />
                                </van-cell>
                                <van-cell title="余额消费" clickable @click="radio = '2'">
                                    <van-radio slot="right-icon" name="2" />
                                </van-cell>
                            </van-radio-group>
                        </div>
                        <van-button type="primary" size="large" @click="handleSearch">搜索</van-button>
                    </div>
                </van-popup>
            </div>
        </div>
        <div class="search-date">
            <TheSearchByDate :total="total" @handleChangeDate="handleChangeDate"/>
        </div>
        <div class="content">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData">
                <div class="consume-item" v-for="item in consumeList" :key="item.id">
                    <div class="info">
                        <div class="shop-img">
                            <img v-lazy="item.headimgurl" alt="">
                        </div>
                        <div class="price-box">
                            <p class="shop-name">{{item.nickname}}</p>
                            <p v-if="item.type === 1 || item.type === 0">支付金额：<span class="price">￥{{item.amount}}</span></p>
                            <p v-else>支付金额：<span class="price">￥{{item.total_sum}}</span></p>
                            <p>支付代金券：<span class="price">￥{{item.use_djj}}</span></p>
                            <p>商家收款：<span class="price">￥{{item.shop_amount}}</span></p>
                            <p>{{item.created_at}}</p>
                        </div>
                        <div class="time-box">
                        </div>
                    </div>
                    <div class="status">
                        <span v-if="item.type === 0" style="background: #E62E25">付款消费</span>
                        <span v-if="item.type === 1" style="background: #1871F8">充值消费</span>
                        <span v-if="item.type === 2" style="background: #4EBA4E">余额消费</span>
                    </div>
                </div>
            </van-list>
        </div>
    </div>


</template>

<script>
    import {mapState} from 'vuex';
    import BaseHeader from "../components/BaseHeader";
    import {getShopRecordsListService} from "../service/shopService";
    import {Toast} from 'vant';
    import TheSearchByDate from "../components/TheSearchByDate";
	//import {wecharShare} from "../util/weChat.js";
    export default {
        name: "ShopConsumeList",
        data(){
            return{
                consumeList:[],
                loading: false,
                finished: false,
                offset:{
                    page:0,
                    limit:10,
                },
                type:'3',//型 0：付款记录 1:充值记录 2：余额消费 3：所有记录
                show:false,
                startDate:null,
                endDate:null,
                active:null,
                total:0,//总计
                temp:0,
            }
        },
        mounted() {
			//wecharShare(location.href.split('#')[0],location.href.split('#')[1]);
        },
        methods:{

            onClickLeft(){
                this.$router.go(-1)
            },
            //搜索
            handleSearch(){
                this.consumeList = [];
                this.offset.page = 0;
                this.loading = false;
                this.finished = false;
                this.getData();
                this.show = false;
            },

            //改变筛选条件
            handleChangeDate(startDate,endDate){
                this.startDate = startDate;
                this.endDate = endDate;
                this.total = 0;
                this.offset.page = 0;
                this.consumeList = [];
                this.loading = false;
                this.finished = false;
                if(sessionStorage.getItem('t_s_s') && sessionStorage.getItem('t_s_s') === 'yes'){
                    this.getData();
                    sessionStorage.removeItem('t_s_s')
                }

            },

            //获取数据
            getData(){

                this.offset.page++;
                getShopRecordsListService(this.shopId,this.type,this.offset.page,this.offset.limit,this.startDate,this.endDate).then(res => {
                    if(res.status === 1){
                        this.loading = false;
                        if(res.datas.datas.length === 0){
                            this.finished = true;
                            return;
                        }
                        if(res.datas.datas.length > 0){
                            this.total = res.datas.sum_num;
                        }
                        this.consumeList = [... this.consumeList,...res.datas.datas];
                    }else{
                        Toast(res.msg);
                    }
                }).catch(err => {
                    console.log(err);
                })
            }
        },
        computed:{
            ...mapState({
                shopId: state => state.userInfo.shopId,
            })
        },
        components:{
            BaseHeader,
            TheSearchByDate
        }
    }
</script>

<style scoped lang="scss">
    .wrapper{
        background: #FFFFFF!important;
        .my-header{
            .search-content{
                .search-box{
                    padding: 10px;
                    box-sizing: border-box;
                }
            }
        }
        .content{
            background: #FFFFFF!important;
            padding: 20px 15px;
            box-sizing: border-box;
            .consume-item{
                position: relative;
                color: #333333;
                margin-bottom: 20px;
                background: #ffffff;
                padding: 10px;
                box-sizing: border-box;
                border-radius: 10px;
                box-shadow:0px 3px 17px 1px rgba(203,201,197,0.23);
                overflow: hidden;
                .info{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .shop-img{
                        flex: 20%;
                        img{
                            width: 80px;
                            height: 80px;
                            border-radius: 50%;
                        }
                    }
                    .price-box{
                        flex: 80%;
                        margin-left: 10px;
                        p{
                            padding: 5px 0;
                        }
                        .price{
                            font-size: 16px;
                            color: rgb(208,45,96);
                        }
                    }

                }
                .status{
                    position: absolute;
                    top: 15px;
                    right: -20px;
                    transform: rotate(45deg);
                    span{
                        padding: 5px 20px;
                        box-sizing: border-box;
                        color: #ffffff;
                    }
                }
            }
        }

    }
</style>